import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=d7da51fa&scoped=true&"
import script from "./QuestionImage.vue?vue&type=script&lang=js&"
export * from "./QuestionImage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionImage.vue?vue&type=style&index=0&id=d7da51fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7da51fa",
  null
  
)

export default component.exports